module.exports = __webpack_public_path__ + "media/reskin-images/icon--expand-video-4a2ef6a7.svg";